<template>
    <div name="post" class="post">
        <div class="contents" v-if="state===0">
            <img class="close" src="../../../assets/close_icn.png" @click="close" />
            <span class="title">1형 당뇨인 불편접수함</span>
            <span class="description" style="margin-top: 8px;">남겨주신 의견을 바탕으로 하나씩 개선하고 있습니다. <br>작은 불편함이든 큰 불편함이든, 불편한 순간이 생각 나셨다면 꼭 의견을 남겨주세요.</span>
            <span class="label" style="margin-top: 32px;">1형당뇨 연차</span>
            <input 
                type="text"
                inputmode="numeric"
                maxlength="2"
                v-focus-input-style
                class="input"
                ref="yearCount"
                v-model="yearCount"
                placeholder="숫자만 입력해 주세요."
                style="margin-top: 20px;"
            />
            <span style="margin-top: 4px;" class="error_message">{{ yearCountError }}</span>
            <div class="line"></div>
            <div class="wrapper">
                <textarea
                    :placeholder="placeholder"
                    class="textarea"
                    v-model="contents"
                    v-focus-input-style
                    ref="contents"
                ></textarea>
                <span class="text-count"><span :style="contents.length > 0 ? 'color: var(--Blue-01_Primary-blue, #008DEF)' : ''">{{ contents.length }}</span>/200</span>
            </div>
            
            <div class="row" style="margin-top: 8px;">
                <img class="icon" src="../../../assets/warning2.png" />
                <div class="col" style="margin-left: 4px;">
                    <span class="info-text">등록 후에는 수정, 삭제가 불가능합니다.</span>
                    <span class="info-text">200자 이내로 작성해 주세요.</span>
                </div>
            </div>
            <span style="margin-top: 8px; margin-bottom: 68px" class="error_message">{{ contentsError }}</span>
            <div class="row" style="justify-content: space-between; align-items: center; width: 100%; position:fixed; bottom: 0;left: 0; padding: 0 16px 32px 16px; box-sizing: border-box;">
                <div class="cancel-button" style="width: calc(50% - 8px);" @click="close">
                    취소
                </div>
                <div class="submit-button" style="margin-left: 16px;width: calc(50% - 8px);" @click="submit">
                    불편 접수하기
                </div>
            </div>
        </div>
        <div class="cancel" v-else-if="state === 1">
            <span class="cancel-title">작성중인 내용이 있습니다</span>
            <span class="cancel-description" style="margin-top: 20px;">이대로 나가시면, 작성중이던 내용이 사라질 수 있어요.<br><br>그래도 나가시겠어요?</span>
            <div class="col" style="justify-content: space-between; align-items: center; width: 100%; margin-top: 48px;">
                <div class="submit-button" style="width: 100%;" @click="closeForce">
                    네, 나갈게요
                </div>
                <div class="cancel-button" style="width: 100%; border: 0" @click="cancelClose">
                    아니요
                </div>
            </div>
        </div>
        <div class="submit" v-else>
            <img style="width: 118px;" src="../../../assets/crap.png" />
            <span class="submit-title" style="margin-top: 20px;">소중한 의견을 남겨주셔서 감사합니다!</span>
            <span class="submit-description" style="margin-top: 20px;">오늘 남겨주신 의견을 바탕으로</span>
            <span class="submit-description">1형 당뇨인을 위한 더 나은 미래를 만들어가겠습니다.</span>
            <div class="submit-button" style="width: 100%; margin-top: 52px;" @click="onSubmit">
                확인
            </div>
        </div>
    </div>
</template>

<script>
import focusInputStyle from '@/components/directives/focusInputStyle';
import Constant from '@/constant';
import {mapState} from 'vuex'
import Convert from '@/utilities/convert'

export default {
    name: 'post',
    computed: mapState(['vocDiabetes']),
    data: function()
    {
        return {
            placeholder: `솔닥 컨시어지 사용 여부와 상관 없이 자유롭게 알려주세요. 

여러분이 들려주신 불편함이
다른 누군가의 평범한 일상을 되찾는 실마리가 될 수 있습니다. 
            
솔닥 컨시어지는 해결할 수 있는 방법을 끝까지 찾아보겠습니다.`,
            yearCount: null,
            contents: '',
            state: 0,
            yearCountError: '',
            contentsError: ''
        }
    },
    directives: {
        focusInputStyle
    },
    mounted: function()
    {
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
    },  
    methods: {
        close: function()
        {
            if(this.contents !== '')
            {
                this.state = 1;
            }
            else
            {
                document.body.style.overflow = ''; // 스크롤 활성화
                this.$emit('onClose')
            }
        },
        onSubmit: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('onSubmit')
        },  
        cancelClose: function()
        {
            this.state = 0;
        },
        closeForce: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('onClose')
        },
        submit: function()
        {
            if(this.yearCount === undefined || this.yearCount === null || this.yearCount === '')
            {
                this.errorFocus('yearCount')
                this.yearCountError = '내용을 입력해 주세요.'
                return;
            }

            if(!Convert.isNumeric(this.yearCount))
            {
                this.errorFocus('yearCount')
                this.yearCountError = '숫자를 입력해 주세요.'
                return;
            }


            if(this.contents.length > 200)
            {
                this.errorFocus('contents')
                this.contentsError = '200자 이내로 작성해 주세요.'; 
                return;
            }
            if(this.contents.trim() === '')
            {
                this.errorFocus('contents')
                this.contentsError = '내용을 입력해 주세요.'; 
                return;
            }
            if(this.contents === undefined || this.contents === null || this.contents === '' )
            {
                this.errorFocus('contents')
                this.contentsError = '내용을 입력해 주세요.'; 
                return;
            }


            this.$store.commit(Constant.INITIALIZE_DIABETES_VOC)
            this.vocDiabetes.contents = this.contents;
            this.vocDiabetes.yearCount = this.yearCount;
            this.$store.dispatch(Constant.ADD_DIABETES_VOC)
                .then((res) => {
                    this.state = 2;
                })
                .catch((err) => {
                    
                })
                
        },
        errorFocus: function(field)
        {
            this.$refs[field].style.border = '1px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        },
    },
    watch: {
        yearCount: function()
        {
            if(!Convert.isNumeric(this.yearCount))
            {
                this.yearCount = this.yearCount.replace(/[^0-9]/g, "");
            }
            this.yearCountError = '';
        },
        contents: function()
        {
            
            if(this.contents.length > 200)
            {
                this.errorFocus('contents')
                this.contents = this.contents.substring(0, 200);
                this.contentsError = '200자 이내로 작성해 주세요.'; 
                return;
            }
            else {
                this.contentsError = '';
            }
        }
    }
}
</script>

<style scoped>
    .post {
        position: fixed;
        z-index: 6;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        overflow-y: auto;
        background: rgba(0, 0, 0, 0.66);
    }
    .contents {
        width: 100%;
        min-height: 120vh;
        background: var(--Gray-00, #FFF);
        box-sizing: border-box;
        padding: 62px 20px 32px 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        overflow-y: auto;
    }
    .submit {
        height: 426px;
        position: fixed;
        width: 100%;
        background: var(--Gray-00, #FFF);
        bottom: 0;
        border-radius: 16px 16px 0 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 32px 20px;
        box-sizing: border-box;
    }
    .submit-title {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 120% */
    }
    .submit-description{
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
    .cancel {
        height: 323px;
        position: fixed;
        width: 100%;
        background: var(--Gray-00, #FFF);
        bottom: 0;
        border-radius: 16px 16px 0 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 32px 20px;
        box-sizing: border-box;
    }
    .cancel-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 120% */
        letter-spacing: -0.4px;
    }
    .cancel-description {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }

    .close {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 120% */
    }
    .description {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }
    .input {
        width: 100%;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        height: 55px;
        padding: 0 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .label {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
    }
    .textarea {
        width: 100%;
        min-height: 215px;
        resize: none;        /* 크기 조절 비활성화 */
        overflow-y: auto;    /* 내용이 넘치면 스크롤 */
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        border: 0;
        margin-top: 32px;
        padding: 14px;
        box-sizing: border-box;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
    textarea::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .line {
        background: #E8EAEE;
        height: 1px;
        width: 100%;
        margin-top: 32px;
    }
    .icon {
        width: 22px;
    }
    .row {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

    }
    .col {
        display: flex;
        flex-direction: column;
    }
    .info-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }
    .cancel-button {
        display: flex;
        height: 54px;
        width: 84px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-00, #FFF);
        cursor: pointer;
    }
    .submit-button {
        display: flex;
        height: 54px;
        width: 143px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        cursor: pointer;
    }
    .error_message {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
    }
    .wrapper {
        width: 100%;
        position: relative;
    }
    .text-count {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        position: absolute;
        bottom: 16px;
        right: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/m_uncomfortable/Post.vue